import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import './Home.css';
import { TiGroup } from "react-icons/ti";
import { MdConstruction, MdSettings, MdOutlineBarChart } from "react-icons/md";
import UserTypeAPIs from "../../../MasonyFixingsAPIs/UserTypeAPIs/UserTypeAPIs";
import ViewUpcomingTasks from "./ViewUpcomingTasks/ViewUpcomingTasks";


function Home(){

    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [management, setManagement] = useState(false);

    const getUserType = () => {
        UserTypeAPIs.GetUserType()
        .then((response) => {
            if(response.status === 200){
                setLoading(false);
                setManagement(true);
            }
        })
        .catch((err) => {
            console.log(err);
            if(err.response.status === 401){
                if(err.response.data.logout){
                    navigate('/login');
                }
                else{
                    setLoading(false);
                }
            }
        })
    }

    useEffect(() => {
        getUserType();
    });

    if(loading){
        return(
            <h3>Loading home page...</h3>
        )
    }
    else{

        return(
            <div className="home-container">

                
                <div className="home-header">
                    <h3>Welcome back</h3>
                    <p>Select an option to get started or review your tasks below</p>
                </div>

                <div className="home-section">
                    <h5 className="section-title">Quick Actions</h5>

                    <div className="home-actions">
                    <div className="action-card" onClick={() => navigate('project')}>
                        <MdConstruction className="icon" />
                        <span>Projects</span>
                    </div>

                    <div className="action-card" onClick={() => navigate('companies')}>
                        <TiGroup className="icon" />
                        <span>Companies</span>
                    </div>

                    {management && (
                        <div className="action-card" onClick={() => navigate('analytics')}>
                        <MdOutlineBarChart className="icon" />
                        <span>Analytics</span>
                        </div>
                    )}

                    {management && (
                        <div className="action-card" onClick={() => navigate('maintenance')}>
                        <MdSettings className="icon" />
                        <span>Maintenance</span>
                        </div>
                    )}
                    </div>
                </div>

                <div className="home-section">
                    <h5 className="section-title">Upcoming Tasks</h5>

                    <div className="tasks-card">
                    <ViewUpcomingTasks />
                    </div>
                </div>

                </div>
        );
    }
}
export default Home;